import React, { useEffect } from 'react';
import styled from 'styled-components/native';
import { B } from '../../../../components/Typography';
import { ScreenComponentPlugin } from '../ScreenComponentPlugin';
import { useNavigation } from '@react-navigation/core';
import { StackNavigationProp } from '@react-navigation/stack';
import { StudyParticipant } from '../../../../models/StudyParticipant';
import { Feather } from '@expo/vector-icons';
import { useGetStudyParticipantNotes } from '../../../../hooks/study/useGetStudyParticipantNotes';
import ActivityIndicatorScreen from '../../../../components/ActivityIndicatorScreen';

const StyledCardView = styled.TouchableOpacity`
  flex-direction: row;
  background: #def9ff;
  width: 100%;
  border-radius: 24px;
  shadow-color: #111111;
  shadow-offset: 0 16px;
  shadow-opacity: 0.1;
  shadow-radius: 48px;
  padding: 16px 22px 16px 16px;
  min-height: 80px;
  align-items: center;
`;

const StyledAccessoryContainerView = styled.View`
  flex: 1 1 auto;
  align-items: flex-end;
`;

interface NotebookCardProps {
  title?: string;
  studyParticipant?: StudyParticipant;
}

const NotebookCard: React.FC<NotebookCardProps> = ({
  title = 'Notes',
  studyParticipant
}) => {
  const navigation = useNavigation<StackNavigationProp<any>>();
  const {
    studyParticipantNotes,
    loadingStudyParticipantNotes,
    getStudyParticipantNotes
  } = useGetStudyParticipantNotes(studyParticipant?.id || 0);
  useEffect(() => {
    if (studyParticipant) {
      getStudyParticipantNotes();
    }
  }, [getStudyParticipantNotes, studyParticipant]);
  return (
    <StyledCardView
      activeOpacity={0.7}
      onPress={() => {
        navigation.navigate('StudiesNav', {
          screen: 'StudyNotebook',
          params: { studyParticipantId: studyParticipant?.id }
        });
      }}
    >
      <B color='dark'>
        {title} ({studyParticipantNotes ? studyParticipantNotes.length : 0})
      </B>
      <StyledAccessoryContainerView>
        <Feather name='chevron-right' size={24} />
      </StyledAccessoryContainerView>
      {loadingStudyParticipantNotes && (
        <ActivityIndicatorScreen backgroundColor='transparent' color='white' />
      )}
    </StyledCardView>
  );
};

export const NotebookCardPlugin: ScreenComponentPlugin<NotebookCardProps> = {
  type: 'NotebookCard',
  name: 'Notebook Card',
  categories: ['study-progress'],
  component: NotebookCard
};
